<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span *ngIf="!editMode">Adicionar novo Contato</span>
                    <span *ngIf="editMode">Editar Contato</span>
                </h4>                 
            </div>
            <div class="modal-body">
                <ng-template [ngIf]="isLoading">
                    <p class="text-center">
                        <i class='fas fa-spinner fa-pulse'></i> Carregando contato
                    </p>
                </ng-template>
                
                <ng-template [ngIf]="!isLoading">
                    <div class="row" *ngIf="pessoa">
                        <div class="form-group col-12">
                            <label class="col-form-label">{{labelPessoa}}</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">{{pessoa.codigoIntegracaoErp}}</span>
                                </div>
                                <input type="text" class="form-control" [value]="pessoa.nome" disabled="disabled" readonly="readonly">
                            </div>
                            <p class="form-text text-muted">
                                {{pessoa.nomeFantasia}} - {{pessoa.cnpjCpf}} - {{pessoa.enderecoPrincipal?.cidade?.nome}} - {{pessoa.enderecoPrincipal?.cidade?.estado?.uf}}
                            </p>
                        </div>
                    </div>

                    <hr/>

                    <div class="row" *ngIf="showForm">
                        <div class="col-12">
                            <sgt-pessoa-contato-form
                                #form>
                            </sgt-pessoa-contato-form>
                        </div>
                    </div>
                </ng-template>                
            </div>
            <div class="modal-footer">      
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-success" (click)="save()" id="btnPessoaContatoSave">
                    Salvar
                </button>                         
            </div>            
        </div>
    </div>
</div>